import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { MutationFetchFunction } from 'common/helpers/common';
import { ApiError, ApiResult } from 'common/repositories/common.model';

import {
  ProductListModel,
  ProductListMutationDeleteInput,
  ProductListMutationInput,
  ProductListMutationUpdateInput,
} from './model';

export function useCreateProductList(
  options?: UseMutationOptions<
    ApiResult<ProductListModel>,
    ApiError,
    ProductListMutationInput
  >,
) {
  return useMutation<
    ApiResult<ProductListModel>,
    ApiError,
    ProductListMutationInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: 'products',
      method: 'POST',
      body,
    });
  }, options);
}

export function useUpdateProductList(
  options?: UseMutationOptions<
    ApiResult<ProductListModel>,
    ApiError,
    ProductListMutationUpdateInput
  >,
) {
  return useMutation<
    ApiResult<ProductListModel>,
    ApiError,
    ProductListMutationUpdateInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: `products/${body.id}`,
      method: 'PUT',
      body: body.body,
    });
  }, options);
}

export function useDeleteProductList(
  options?: UseMutationOptions<
    ApiResult<any>,
    ApiError,
    ProductListMutationDeleteInput
  >,
) {
  return useMutation<ApiResult<any>, ApiError, ProductListMutationDeleteInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: `products/${body.id}`,
        method: 'DELETE',
      });
    },
    options,
  );
}
